import { render } from "./AppHeader.vue?vue&type=template&id=6aa7c28c"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=6aa7c28c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__